import React from "react"
import { FaTimes } from "react-icons/fa"

import { moment } from "utils"
import { Modal } from "components"
import StrrdmResponseTableRow from "./StrrdmResponseTableRow"
import StrrdmRequestTableRow from "./StrrdmRequestTableRow"
import StrrdmReceiveTableRow from "./StrrdmReceiveTableRow"
import StrrdmResolveTableRow from "./StrrdmResolveTableRow"
import classes from "./index.module.scss"

const StrRespondToRequestModal = (props) => {
  const {
    stockTransferRequest,
    openRequestDetailsModal,
    setOpenRequestDetailsModal
  } = props

  const showResponseSection =
    stockTransferRequest.stockTransferStatus !== "pending" &&
    stockTransferRequest.stockTransferStatus !== "canceled"

  const showReceiveSection =
    stockTransferRequest.stockTransferStatus !== "pending" &&
    stockTransferRequest.stockTransferStatus !== "canceled" &&
    stockTransferRequest.stockTransferStatus !== "rejected" &&
    stockTransferRequest.stockTransferStatus !== "approved" &&
    stockTransferRequest.stockTransferStatus !== "inTransit"

  const showResolveSection =
    !!stockTransferRequest.resolverAccountId &&
    stockTransferRequest.stockTransferStatus === "completed"

  return (
    <Modal
      
      size="xl"
      backdrop="static"
      show={openRequestDetailsModal}
      onHide={() => setOpenRequestDetailsModal(false)}
    >
      <div className={classes["container"]}>
        <div>
          <button onClick={() => setOpenRequestDetailsModal(false)}>
            <FaTimes />
          </button>
        </div>

        <div className={classes["title"]}>
          جزئیات درخواست
        </div>

        <div className={classes["header"]}>
          <div className={classes["header-item"]}>
            <span>شماره سند:</span>
            <b className={classes["code"]}>
              {stockTransferRequest.code}
            </b>
          </div>
          <div className={classes["header-item"]}>
            <span>نام ثبت کننده :</span>
            <b>
              {stockTransferRequest.requesterFullName}
            </b>
          </div>

          <div className={classes["header-item"]}>
            <span>تاریخ ثبت :</span>
            <b>
              {moment(stockTransferRequest.createdAt).format("jYYYY/jMM/jDD - HH:mm")}
            </b>
          </div>
        </div>

        <div className={classes["table-container"]}>
          <table className={classes["table"]}>
            <thead>
              <tr>
                <th style={{ width: "55%" }}>
                  نام کالا
                </th>
                <th style={{ textAlign: "center", width: "10%" }}>
                  مقدار درخواستی
                </th>
              </tr>
            </thead>
            <tbody>
              {stockTransferRequest.requestedItems.map(requestedItem =>
                <StrrdmRequestTableRow
                  key={requestedItem.optionId}
                  requestedItem={requestedItem}

                />
              )}
            </tbody>
          </table >
        </div>

        {
          showResponseSection &&
          <div className={classes["section"]}>
            <div className={classes["title"]}>
              جزئیات پاسخ
            </div>

            <div className={classes["header"]}>
              <div className={classes["header-item"]}>
                <span>شماره سند:</span>
                <b className={classes["code"]}>
                  1-{stockTransferRequest.code}
                </b>
              </div>
              <div className={classes["header-item"]}>
                <span>نام ثبت کننده :</span>
                <b>
                  {stockTransferRequest.responderFullName}
                </b>
              </div>

              <div className={classes["header-item"]}>
                <span>تاریخ ثبت پاسخ :</span>
                <b>
                  {moment(stockTransferRequest.respondDate).format("jYYYY/jMM/jDD - HH:mm")}
                </b>
              </div>

              {
                !!stockTransferRequest.startDeliveryDate &&
                <div className={classes["header-item"]}>
                  <span>تاریخ ارسال محموله :</span>
                  <b>
                    {moment(stockTransferRequest.startDeliveryDate).format("jYYYY/jMM/jDD - HH:mm")}
                  </b>
                </div>
              }
            </div>

            {
              stockTransferRequest.responseMessage &&
              <div className={classes["note-container"]}>
                <div className={classes["note-label"]}>
                  پاسخ به درخواست:
                </div>
                <div className={classes["note"]}>
                  {stockTransferRequest.responseMessage}
                </div>
              </div>
            }

            <div className={classes["table-container"]}>
              <table className={classes["table"]}>
                <thead>
                  <tr>
                    <th></th>
                    <th style={{ width: "60%" }}>
                      نام کالا
                    </th>
                    <th style={{ textAlign: "center" }}>
                      مقدار درخواستی
                    </th>
                    <th style={{ textAlign: "center" }}>
                      مقدار قبول شده
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {stockTransferRequest.requestedItems.map(requestedItem =>
                    <StrrdmResponseTableRow
                      key={requestedItem.optionId}
                      requestedItem={requestedItem}
                    />
                  )}
                </tbody>
              </table >
            </div>
          </div>
        }

        {
          showReceiveSection &&
          <div className={classes["section"]}>
            <div className={classes["title"]}>
              گزارش دریافت
            </div>

            <div className={classes["header"]}>
              <div className={classes["header-item"]}>
                <span>شماره سند:</span>
                <b className={classes["code"]}>
                  2-{stockTransferRequest.code}
                </b>
              </div>

              <div className={classes["header-item"]}>
                <span>نام دریافت کننده:</span>
                <b>
                  {stockTransferRequest.receiverFullName}
                </b>
              </div>

              <div className={classes["header-item"]}>
                <span>تاریخ دریافت:</span>
                <b>
                  {moment(stockTransferRequest.receivedDate).format("jYYYY/jMM/jDD - HH:mm")}
                </b>
              </div>

            </div>

            {
              stockTransferRequest.receivedNote &&
              <div className={classes["note-container"]}>
                <div className={classes["note-label"]}>
                  یادداشت:
                </div>
                <div className={classes["note"]}>
                  {stockTransferRequest.receivedNote}
                </div>
              </div>
            }

            <div className={classes["table-container"]}>
              <table className={classes["table"]}>
                <thead>
                  <tr>
                    <th></th>
                    <th style={{ width: "55%" }}>
                      نام کالا
                    </th>
                    <th style={{ textAlign: "center" }}>
                      مقدار درخواستی
                    </th>
                    <th style={{ textAlign: "center" }}>
                      مقدار قبول شده
                    </th>
                    <th style={{ textAlign: "center" }}>
                      مقدار دریافت شده
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {stockTransferRequest.requestedItems.map(requestedItem =>
                    requestedItem.acceptedQuantity !== 0 &&
                    <StrrdmReceiveTableRow
                      key={requestedItem.optionId}
                      requestedItem={requestedItem}
                    />
                  )}
                </tbody>
              </table >
            </div>
          </div>
        }

        {
          showResolveSection &&
          <div className={classes["section"]}>
            <div className={classes["title"]}>
              گزارش مناقصه
            </div>

            <div className={classes["header"]}>
              <div className={classes["header-item"]}>
                <span>شماره سند:</span>
                <b className={classes["code"]}>
                  3-{stockTransferRequest.code}
                </b>
              </div>

              <div className={classes["header-item"]}>
                <span>نام ثبت کننده:</span>
                <b>
                  {stockTransferRequest.resolverFullName}
                </b>
              </div>

              <div className={classes["header-item"]}>
                <span>تاریخ حل مناقصه:</span>
                <b>
                  {moment(stockTransferRequest.resolveDiscrepancyDate).format("jYYYY/jMM/jDD - HH:mm")}
                </b>
              </div>

            </div>

            {
              stockTransferRequest.resolveNote &&
              <div className={classes["note-container"]}>
                <div className={classes["note-label"]}>
                  یادداشت:
                </div>
                <div className={classes["note"]}>
                  {stockTransferRequest.resolveNote}
                </div>
              </div>
            }

            <div className={classes["table-container"]}>
              <table className={classes["table-resolve"]}>
                <thead>
                  <tr>
                    <th style={{ width: "0%" }}></th>
                    <th style={{ width: "25%" }}>
                      نام کالا
                    </th>
                    <th style={{ textAlign: "center", width: "5%" }}>
                      مقدار درخواستی
                    </th>
                    <th style={{ textAlign: "center", width: "5%" }}>
                      مقدار قبول شده
                    </th>
                    <th style={{ textAlign: "center", width: "5%" }}>
                      مقدار دریافت شده
                    </th>
                    <th style={{ textAlign: "center", width: "5%" }}>
                      مقدار مرجوع شده
                    </th>
                    <th style={{ textAlign: "center", width: "5%" }}>
                      مقدار باز دریافت
                    </th>
                    <th style={{ textAlign: "center", width: "5%" }}>
                      مقدار کسری
                    </th>
                    <th style={{ textAlign: "center", width: "5%" }}>
                      مقدار ضایعات
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {stockTransferRequest.requestedItems.map(requestedItem =>
                    requestedItem.acceptedQuantity !== requestedItem.receivedQuantity &&
                    <StrrdmResolveTableRow
                      key={requestedItem.optionId}
                      requestedItem={requestedItem}
                    />
                  )}
                </tbody>
              </table >
            </div>
          </div>
        }

      </div>
    </Modal >
  )
}

export default StrRespondToRequestModal